export default __webpack_public_path__ + "static/image08-fff836de8eb4acde1534bf0c6ff657eb.webp";